export default __webpack_public_path__ + "6ae2182ab0e400ff8e2d881e4b18f9a3.png";